import { useParams } from "react-router-dom"
import InnerHeader from "../../Layouts/InnerHeader"
import Loading from "../../Layouts/Loading"
import Error404 from "../../Layouts/Error404"
import { fa_number } from "../../utils/Persian"
import Factor from "./Factor"
import { useGetFactorQuery } from "../../Redux/Apis/shopApi"
import PrintableFactor from "./PrintableFactor"

export default function FactorView() {
    let {factorId} = useParams();

    const {
        data,
        isLoading,
        isSuccess,
        isError,
    } = useGetFactorQuery(factorId)

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Factor/>

    else if(isSuccess && data) {
        return(
            <div className="container-lg">
                <InnerHeader name={`فاکتور شماره ${fa_number(data.id)}`} root='/factor'/>
                <PrintableFactor data={data} />
            </div>
        )
    }

    else return <Error404/>
}